// Student Stories data for CEPRES International University

export const studentStories = [
  {
    id: 'james-kollie',
    name: 'James K. Kollie',
    program: 'Bachelor of Public Health',
    graduationYear: '2023',
    currentRole: 'Disease Surveillance Officer, Ministry of Health',
    location: 'Monrovia, Liberia',
    image: 'https://customer-assets.emergentagent.com/job_479182d4-7fde-4a87-91a5-42a6ac4fac5e/artifacts/ptyry2rh_WhatsApp%20Image%202026-02-04%20at%2017.35.12%20%283%29.jpeg',
    videoUrl: null,
    quote: 'CEPRES transformed my career. The flexible Fast Track program allowed me to continue working while studying, and now I\'m leading disease surveillance efforts for the entire country.',
    story: `
      When James enrolled at CEPRES, he was working as a community health volunteer with no formal qualifications. The Fast Track program allowed him to complete his degree in just 2 years while maintaining his job.

      "The practical approach at CEPRES was exactly what I needed. We didn't just learn theory - we applied everything in real communities," James recalls.

      Today, James leads a team of 50 surveillance officers and has been instrumental in Liberia's COVID-19 response efforts. He credits his success to the hands-on training and mentorship he received at CIU.

      His advice to prospective students: "Don't let your circumstances hold you back. CEPRES is designed for people like us - working professionals who want to make a difference."
    `,
    featured: true,
  },
  {
    id: 'mary-weah',
    name: 'Mary T. Weah',
    program: 'Bachelor of Community Health',
    graduationYear: '2022',
    currentRole: 'Program Manager, International NGO',
    location: 'Bong County, Liberia',
    image: 'https://customer-assets.emergentagent.com/job_479182d4-7fde-4a87-91a5-42a6ac4fac5e/artifacts/vfz74n9l_WhatsApp%20Image%202026-02-04%20at%2017.35.14%20%285%29.jpeg',
    videoUrl: null,
    quote: 'The research skills I gained at CEPRES helped me win a national award. More importantly, my work is saving lives in rural communities.',
    story: `
      Mary always dreamed of improving healthcare in her community but lacked the credentials to make a real impact. CEPRES changed everything.

      During her studies, she conducted groundbreaking research on malaria prevention that earned her national recognition. Her community-based intervention strategies have been adopted by several NGOs working in Liberia.

      "What I love about CEPRES is how they encouraged us to think beyond the classroom. Every assignment was connected to real problems in our communities," Mary explains.

      Now managing health programs across multiple counties, Mary regularly returns to CIU as a guest lecturer, inspiring the next generation of community health professionals.
    `,
    featured: true,
  },
  {
    id: 'samuel-dahn',
    name: 'Samuel G. Dahn',
    program: 'BSc Sustainable Agriculture',
    graduationYear: '2024',
    currentRole: 'Agricultural Extension Officer',
    location: 'Nimba County, Liberia',
    image: 'https://customer-assets.emergentagent.com/job_479182d4-7fde-4a87-91a5-42a6ac4fac5e/artifacts/yfrf73c9_WhatsApp%20Image%202026-02-04%20at%2017.35.14%20%287%29.jpeg',
    videoUrl: null,
    quote: 'CEPRES taught me that agriculture is the key to food security and economic development. Now I\'m helping farmers transform their livelihoods.',
    story: `
      Samuel grew up on a small family farm and saw firsthand the challenges farmers face. He enrolled at CEPRES to learn modern, sustainable farming techniques.

      The BSc Sustainable Agriculture program gave him both theoretical knowledge and practical skills. He completed his internship with the Ministry of Agriculture and was offered a full-time position before graduation.

      "The campus farm project was incredible. We learned by doing - planting, harvesting, and even selling our produce at the local market," Samuel shares.

      Today, Samuel works with over 200 farmers in Nimba County, helping them adopt sustainable practices that increase yields while protecting the environment.
    `,
    featured: true,
  },
  {
    id: 'patricia-johnson',
    name: 'Patricia N. Johnson',
    program: 'Diploma in Public Health',
    graduationYear: '2023',
    currentRole: 'Health Facility Manager',
    location: 'Grand Bassa County, Liberia',
    image: 'https://customer-assets.emergentagent.com/job_479182d4-7fde-4a87-91a5-42a6ac4fac5e/artifacts/mp7kzwiz_WhatsApp%20Image%202026-02-04%20at%2017.35.15%20%284%29.jpeg',
    videoUrl: null,
    quote: 'The vocational diploma program was perfect for my needs. In just 12 months, I gained the skills to manage a health facility.',
    story: `
      Patricia had been working at a rural health clinic for years but was passed over for promotion because she lacked formal qualifications. The Institute of Professional Studies at CEPRES offered her a pathway to advancement.

      The Diploma in Public Health program fit perfectly into her schedule. Weekend classes and online modules allowed her to continue working while studying.

      "The instructors understood our challenges. Many of them had similar backgrounds and could relate to what we were going through," Patricia recalls.

      Within three months of graduation, Patricia was promoted to facility manager. She now oversees a team of 15 health workers and has implemented several improvements that have increased patient satisfaction.
    `,
    featured: false,
  },
  {
    id: 'emmanuel-kamara',
    name: 'Emmanuel B. Kamara',
    program: 'Bachelor of Health Accounting',
    graduationYear: '2024',
    currentRole: 'Healthcare Finance Analyst',
    location: 'Monrovia, Liberia',
    image: 'https://customer-assets.emergentagent.com/job_479182d4-7fde-4a87-91a5-42a6ac4fac5e/artifacts/bnx3f2sc_WhatsApp%20Image%202026-02-04%20at%2017.35.13.jpeg',
    videoUrl: null,
    quote: 'The intersection of healthcare and finance fascinated me. CEPRES gave me the unique skills to work in this growing field.',
    story: `
      Emmanuel had a background in accounting but wanted to apply his skills in the healthcare sector. The Bachelor of Health Accounting program at CEPRES was exactly what he was looking for.

      "Learning about blockchain, AI, and data analytics in the context of healthcare was eye-opening. These are the tools that will transform how we manage health systems," Emmanuel explains.

      His capstone project on health insurance fraud detection caught the attention of a major healthcare provider, leading to a job offer before graduation.

      Emmanuel now works with hospitals and clinics across Liberia, helping them improve their financial systems and reduce waste.
    `,
    featured: false,
  },
  {
    id: 'grace-kpadeh',
    name: 'Grace A. Kpadeh',
    program: 'Bachelor of Primary Education',
    graduationYear: '2022',
    currentRole: 'School Principal',
    location: 'Lofa County, Liberia',
    image: 'https://customer-assets.emergentagent.com/job_479182d4-7fde-4a87-91a5-42a6ac4fac5e/artifacts/an0m2tpw_WhatsApp%20Image%202026-02-04%20at%2017.35.14%20%286%29.jpeg',
    videoUrl: null,
    quote: 'Education is the foundation of everything. CEPRES prepared me to lead schools that change children\'s lives.',
    story: `
      Grace was a primary school teacher for 10 years before deciding to pursue her degree at CEPRES. She chose the Standard Track, completing her studies in 3 years while continuing to teach.

      "The education program at CEPRES is different. It's not just about teaching methods - it's about understanding how children learn and creating environments where they can thrive," Grace shares.

      Her innovative approach to early literacy earned recognition from the Ministry of Education. She was appointed principal of her school, where she has implemented programs that have significantly improved reading scores.

      Grace is now mentoring other teachers through the CIU Alumni Association's mentorship program.
    `,
    featured: false,
  },
];

// Get featured stories
export const getFeaturedStories = () => studentStories.filter(story => story.featured);

// Get story by ID
export const getStoryById = (id) => studentStories.find(story => story.id === id);
